import { render } from "./CourseDetails.vue?vue&type=template&id=2fc14985&ts=true"
import script from "./CourseDetails.vue?vue&type=script&lang=ts"
export * from "./CourseDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__